import { Injectable } from '@angular/core';
import { OfferDataService } from '../data/offer.service';
import {
  Observable,
  BehaviorSubject,
  Subscription,
  AsyncSubject,
  forkJoin,
  of,
} from 'rxjs';
import { map, switchMap, first, mergeAll } from 'rxjs/operators';
import { AddOfferModel } from '../interfaces/interfaces';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class OfferLogicService {
  constructor(private offerDataService: OfferDataService) {}

  addOfferLogic(url: string, file: any) {
    return this.offerDataService
      .uploadOfferImageData(file, moment().valueOf() + '-' + 'offer')
      .pipe(
        first(),
        map((v) =>
          this.offerDataService.addOfferData(new AddOfferModel('offer', url, v))
        ),
        mergeAll()
      );
  }
}
